<template>
  <div>
    <PageAllow controller="Examines" action="view" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("CRUD.info", [$t("Examine.ObjectName")]) }}
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="examine.is_examined | examineStatusColor"
                :text-color="examine.is_examined | examineStatusTextColor"
                >{{ examine.is_examined | examineStatusText }}
              </v-chip>
              <v-spacer />
              <ExamineActions
                :examine="examine"
                :showExamine="
                  isView && examine.actions ? examine.actions.examine : false
                "
                :showAbnormal="
                  isView && examine.actions ? examine.actions.abnormal : false
                "
                :showReturn="examine.return_flg ? true : false"
                detail-mode
                @edit="mode = 'edit'"
              />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="savable"
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="mode = 'view'"
                >
                  <v-icon x-small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backForModify") }}
                </v-btn>
                <v-btn
                  v-if="
                    savable &&
                    $permission.permissionAllow('Examines', 'examine')
                  "
                  small
                  :disabled="loading"
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("Examine.actions.examine_abnormal_edit") }}
                </v-btn>
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.examine_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ examine.examine_code }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="d-none d-md-inline">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    <a
                      class="text-no-wrap"
                      :href="'/#/orders/' + examine.order_id"
                      style="text-decoration: none"
                    >
                      {{ examine.order_code }}
                    </a>
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="d-none d-md-inline">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.distribution_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    <a
                      class="text-no-wrap"
                      :href="'/#/distributions/' + examine.distributions_id"
                      style="text-decoration: none"
                    >
                      {{ examine.distributions_code }}
                    </a>
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.created_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ examine.created | formatTime }}
                </v-card>
              </v-col>
              <v-col v-if="isView" cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.examine_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span> {{ examine.examine_time | formatTime }}</span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.examiner")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="examine.examine_flg == 1">
                    {{ examine.shop_user_name }}
                  </span>
                  <span v-else>
                    {{ examine.examine_flg | examineFlgsText }}</span
                  >
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="d-inline d-md-none">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    <a
                      class="text-no-wrap"
                      :href="'/#/orders/' + examine.order_id"
                      style="text-decoration: none"
                    >
                      {{ examine.order_code }}
                    </a>
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="d-inline d-md-none">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.distribution_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    <a
                      class="text-no-wrap"
                      :href="'/#/distributions/' + examine.distributions_id"
                      style="text-decoration: none"
                    >
                      {{ examine.distributions_code }}
                    </a>
                  </span>
                </v-card>
              </v-col>
              <v-col v-if="isView" cols="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.distribution_info")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      (examine && examine.stock ? examine.stock.name : "") +
                      " - " +
                      examine.distribution_user_name
                    }}
                  </span>
                </v-card>
              </v-col>
              <v-col v-if="savable" cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.distribution_info")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      (examine && examine.stock ? examine.stock.name : "") +
                      " - " +
                      examine.distribution_user_name
                    }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{
                      $t("Examine.DetailFields.shop_name", [
                        $consts.shopName(),
                      ])
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ examine && examine.shop ? examine.shop.shop_name : "" }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.receiver")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      receiverInfo
                        ? receiverInfo.user_name
                        : examine.shop_user_name
                    }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="8">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Examine.DetailFields.contact_number")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>{{
                    receiverInfo
                      ? receiverInfo.tel
                      : examine && examine.shop && examine.shop.shop_user
                      ? examine.shop.shop_user.tel
                      : ""
                  }}</span>
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{
                      $t("Examine.DetailFields.shop_address", [
                        $consts.shopName(),
                      ])
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="receiverInfo">{{ receiverInfo.address }}</span>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text"
                    >{{ $t("Examine.DetailFields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ examine.account_memo }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 d-flex overflow-auto" outlined tile>
                  <!-- 附件 -->
                  <span class="secondary--text text-no-wrap">
                    {{ $t("Order.Fields.attachments") }}{{ $t("Global.colon") }}
                  </span>
                  <!-- 上传图片集 -->
                  <span class="ml-4">
                    <v-card
                      height="160"
                      width="240"
                      v-if="album && album.length > 0"
                    >
                      <v-carousel hide-delimiters height="160" width="240">
                        <v-carousel-item v-for="(item, i) in album" :key="i">
                          <v-img
                            :src="item"
                            @click.stop="$showFullscreenImages(album, i)"
                            v-if="
                              item.startsWith('data:image/') ||
                              ['jpg', 'jpeg', 'gif', 'png'].includes(
                                item
                                  .substring(item.lastIndexOf('.') + 1)
                                  .toLowerCase()
                              )
                            "
                          >
                            <v-tooltip right v-if="savable && item">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="secondary"
                                  class="pa-2 float-right"
                                  @click.stop="removeFromImages(i)"
                                >
                                  fa-times
                                </v-icon>
                              </template>
                              <span> {{ $t("Material.delImg") }}</span>
                            </v-tooltip>
                          </v-img>
                          <div
                            v-else
                            width="240"
                            height="160"
                            style="position: relative"
                          >
                            <span
                              style="
                                position: absolute;
                                top: 0;
                                right: 0;
                                z-index: 99;
                              "
                              @click.stop="removeFromImages(i)"
                              v-if="savable && item"
                            >
                              <v-icon
                                color="secondary"
                                class="pa-2 float-right"
                              >
                                fa-times
                              </v-icon>
                            </span>
                            <video width="240" height="160" controls>
                              <source :src="item" type="video/mp4" />
                            </video>
                          </div>
                        </v-carousel-item>
                      </v-carousel>
                    </v-card>
                    <v-file-input
                      ref="imgs_file"
                      v-if="savable"
                      show-size
                      counter
                      small-chips
                      multiple
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :hint="$t('Material.imgsHint')"
                      :rules="imgsRules"
                      v-model="imgs_file"
                    >
                    </v-file-input>
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("Distribution.actions.activities") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="examine_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        :headers="detailsHeaders"
        :items="examineDetails"
        :search="filter"
        disable-pagination
        hide-default-footer
        :no-data-text="$t('Order.DetailNoData')"
        class="elevation-2 px-4 mt-4"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("Examine.ObjectName")]) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <span class="caption secondary--text pt-2">
              {{
                $t(
                  "$vuetify.dataFooter.pageText",
                  examine_details
                    ? [1, examine_details.length, examine_details.length]
                    : [0, 0, 0]
                )
              }}
            </span>
            <v-spacer />
            <v-row no-gutters class="me-n3">
              <v-spacer />
              <v-col cols="12" sm="9" md="8">
                <v-text-field
                  v-model="filter"
                  clearable
                  hide-details
                  :label="$t('Search.filter')"
                />
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.category_name="{ item }">
          <span class="text-no-wrap">
            <v-icon x-small>
              {{
                item.combineFlg
                  ? "fa-box"
                  : item.hide_flg
                  ? "fa-eye-slash"
                  : "fa-eye"
              }}
            </v-icon>
            {{
              item.combineFlg
                ? $t("Material.Fields.combine_material")
                : item.category_name
            }}
          </span>
        </template>
        <template v-slot:item.material_name="{ item }">
          <span v-if="item.combineFlg">
            <span v-if="item.abnormal_flg" class="danger--text">
              {{ item.ruler_name }}
            </span>
            <span v-else>
              {{ item.ruler_name }}
            </span>
          </span>
          <span v-else>
            <span v-if="item.abnormal_flg" class="danger--text">
              {{ item.material_name }}
            </span>
            <span v-else>
              {{ item.material_name }}
            </span>
            <br />
            <span
              v-if="!item.combineFlg && item.material.standard_name"
              class="caption secondary--text"
            >
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon") }}
              <span
                v-if="
                  item.material.standard_name &&
                  item.material.standard_name.length > 12
                "
                :title="item.material.standard_name"
                style="cursor: pointer"
              >
                {{ item.material.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.material.standard_name }}
              </span>
            </span>
          </span>
        </template>
        <template v-slot:item.order_num="{ item }">
          <span v-if="item.combineFlg">
            {{ item.apply_num | formatTwoDot }}
          </span>
          <span v-else>
            {{ item.order_num | formatTwoDot }}
          </span>
        </template>
        <template v-slot:item.distribution_num="{ item }">
          {{ item.distribution_num | formatTwoDot }}
        </template>
        <template v-slot:item.examine_num="{ item }">
          <NumberInput v-if="savable" v-model="item.examine_num" dense />
          <span v-else-if="item.abnormal_flg" class="danger--text">
            {{ item.examine_num | formatTwoDot }}
          </span>
          <span v-else>
            {{ item.examine_num | formatTwoDot }}
          </span>
        </template>
        <template v-slot:item.stock_examine_num="{ item }">
          <span v-if="!item.combineFlg">
            <!-- 库存单位数量 -->
            <span v-if="examine.is_examined == 0 && !savable">
              {{
                (item.distribution_num *
                  (item.standard_detail.rate / item.stock_unit_rate))
                  | formatTwoDot
              }}{{ item.stock_unit }}
            </span>
            <span v-else>
              {{
                (item.examine_num *
                  (item.standard_detail.rate / item.stock_unit_rate))
                  | formatTwoDot
              }}{{ item.stock_unit }}
            </span>
          </span>
        </template>
        <template v-slot:item.unit="{ item }">
          {{ item.unit }}
          <span
            v-if="item.material && item.standard_detail.rate > 1"
            class="caption secondary--text"
          >
            (1{{ item.unit }}={{ item.standard_detail.rate
            }}{{ item.material.standard.default_standard_detail.unit }})
          </span>
          <span
            v-if="item.standard_detail && item.standard_detail.barcode"
            class="caption secondary--text"
          >
            <br />
            {{ item.standard_detail ? item.standard_detail.barcode : "" }}
          </span>
        </template>
        <template v-slot:item.price="{ item }">
          {{ $t("Global.money") }}{{ item.price | formatMoney }}
        </template>
        <template v-slot:item.subtotal_price="{ item }">
          {{ $t("Global.money") }}{{ item.subtotal_price | moneyFormat }}
        </template>
        <template v-slot:item.qualify_report_img_url="{ item }">
          <!-- 质检报告 -->
          <v-btn
            v-if="
              item &&
              item.qualify_report_img_url &&
              item.qualify_report_img_url.length
            "
            color="orange"
            style="color: white"
            class="my-1"
            small
            @click.stop="
              currentItem = item;
              qualifyReportDialog = true;
            "
          >
            {{ $t("Examine.DetailFields.qualify_report_img") }}
          </v-btn>
        </template>
      </v-data-table>

      <DialogImages
        v-model="qualifyReportDialog"
        :img_url="
          currentItem && currentItem.qualify_report_img_url
            ? currentItem.qualify_report_img_url
            : []
        "
      />
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Examines from "@/api/examines";
import ExamineActions from "./plugins/Actions";
import NumberInput from "@/components/plugins/NumberInput";
import DialogImages from "@/components/plugins/DialogImages";
import Files from "@/api/files";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ExamineActions,
    NumberInput,
    DialogImages,
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },

    savable() {
      return this.mode == "edit";
    },

    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.orderManagement"),
          disabled: false,
          href: "/orders",
        },
        {
          text: i18n.t("Nav.examines"),
          disabled: false,
          href: "/examines",
        },
        {
          text: i18n.t("Nav.examineDetail"),
          disabled: true,
        },
      ];

      return items;
    },

    detailsHeaders() {
      let headers = [
        {
          text: i18n.t("Examine.DetailFields.material_category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("Examine.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("Examine.DetailFields.material_name"),
          align: "start",
          value: "material_name",
        },
        {
          text: i18n.t("Examine.DetailFields.apply_num"),
          align: "start",
          value: "order_num",
        },
        {
          text: i18n.t("Examine.DetailFields.distribute_num"),
          align: "start",
          value: "distribution_num",
        },
        {
          text: i18n.t("Examine.DetailFields.examine_num"),
          align: "center",
          value: "examine_num",
        },
        {
          text: i18n.t("Examine.DetailFields.unit"),
          align: "end",
          value: "unit",
        },
        {
          text: i18n.t("Examine.DetailFields.stock_examine_num"),
          align: "end",
          value: "stock_examine_num",
        },
        {
          text: i18n.t("Examine.DetailFields.price"),
          align: "end",
          value: "price",
        },
        {
          text: i18n.t("Examine.DetailFields.sum"),
          align: "end",
          value: "subtotal_price",
        },
      ];
      if (this.accountSettings && this.accountSettings.qualify_report_enable) {
        headers.push({
          text: i18n.t("Examine.DetailFields.qualify_report_img"),
          align: "start",
          value: "qualify_report_img_url",
        });
      }

      return headers;
    },

    activitiesHeaders: () => [
      {
        text: i18n.t("Examine.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("Examine.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("Examine.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    examineDetails() {
      let item = [];
      this.order_combine_materials.forEach((detail) => {
        item.push(detail);
      });
      this.examine_details.forEach((detail) => {
        item.push(detail);
      });
      return item;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "accountSettings"]),
  },

  data: () => ({
    panels: [0],
    tab: null,
    filter: "",
    mode: "",
    examine: {},
    receiverInfo: {},
    examine_details: [],
    order_combine_materials: [],
    examine_img: [],
    examine_activities: [],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    album: [],
    imgs_file: [],
    currentItem: null,
    qualifyReportDialog: false,
  }),

  mounted() {
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode;
    } else {
      this.mode = "view";
    }
  },

  methods: {
    getExamineDetailFromAPI() {
      Examines.fetchOne(this.$route.params.id, {
        order_activity: 1,
        combine_material: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.examine = response.data.examine;
            this.receiverInfo = response.data.order_address;
            this.examine_details = response.data.examine.examine_details
              ? response.data.examine.examine_details
              : [];
            this.order_combine_materials = response.data.examine
              .order_combine_materials
              ? response.data.examine.order_combine_materials
              : [];
            this.examine_activities = response.data.order_activities;
            this.album = [];
            if (
              response.data.examine &&
              response.data.examine.examine_file_url &&
              response.data.examine.examine_file_url.image_url
            ) {
              response.data.examine.examine_file_url.image_url.forEach(
                (img) => {
                  this.album.push(img);
                }
              );
            }
            if (
              response.data.examine &&
              response.data.examine.examine_file_url &&
              response.data.examine.examine_file_url.video_url
            ) {
              response.data.examine.examine_file_url.video_url.forEach(
                (video) => {
                  this.album.push(video);
                }
              );
            }
            this.examine_details.forEach((detail) => {
              if (this.savable && !detail.examine_num) {
                detail.examine_num = detail.distribution_num;
              }
            });
            this.order_combine_materials.forEach((detail) => {
              if (this.savable && !detail.examine_num) {
                detail.examine_num = detail.distribution_num;
              }
              detail.combineFlg = true;
            });
          }
        }.bind(this)
      );
    },

    async doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      //提交图片集
      var examine_img = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        let response = await Files.filesUpload(this.imgs_file, "images");

        if (response.data.status.isOK()) {
          response.data.data.forEach((file) =>
            examine_img.push(file.file_name)
          );
        }
      }
      let examine_details = [];
      this.examine_details.forEach((detail) => {
        examine_details.push({
          material_id: detail.material.id,
          examine_num: detail.examine_num,
          auto_flg: detail.auto_flg,
          unit: detail.unit,
        });
      });
      let order_combine_materials = [];
      this.order_combine_materials.forEach((detail) => {
        order_combine_materials.push({
          id: detail.id,
          examine_num: detail.examine_num,
        });
      });
      Examines.examine({
        id: this.examine.id,
        examine_img: examine_img,
        examine_details: examine_details,
        order_combine_materials: order_combine_materials,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/examines");
              this.$store.dispatch("fullscreenLoadingStop");
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    removeFromImages(i) {
      this.album.splice(i, 1);
      this.imgs_file.splice(i, 1);
    },
  },

  watch: {
    mode: {
      handler() {
        if (this.$route.params.id) this.getExamineDetailFromAPI();
      },
    },
    examine_details: {
      deep: true,
      handler() {
        this.examine_details.forEach((detail) => {
          if (
            detail.examine_num != detail.distribution_num &&
            this.examine.abnormal_flg
          ) {
            detail.abnormal_flg = 1;
          }
          detail.subtotal_price = this.$numberFormatter.moneyFormat(
            detail.price * detail.examine_num
          ); //小计
        });
      },
    },
    order_combine_materials: {
      deep: true,
      handler() {
        this.order_combine_materials.forEach((detail) => {
          if (
            detail.examine_num != detail.distribution_num &&
            this.examine.abnormal_flg
          ) {
            detail.abnormal_flg = 1;
          }
          detail.subtotal_price = detail.price * detail.examine_num; //小计
        });
      },
    },
    imgs_file: {
      deep: true,
      handler() {
        if (this.imgs_file.length) {
          if (this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.album = [];
            this.imgs_file = [];
          } else {
            this.album = [];
            this.imgs_file.forEach((img, i) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.splice(i, 0, this.result);
              };
            });
          }
        } else {
          this.album = [];
        }
      },
    },
  },
};
</script>